export const MARKETING_HERO_IMAGE = '/images/lezzet-yolda-toptan-hero.png';
export const DEFAULT_WHOLESALER_IMAGE = '/images/ucgul.png';
